import React, { useEffect, useState } from "react";
import { Pressable, ScrollView, StyleSheet, Text, View } from "react-native";
import { useNavigation, useRoute } from "@react-navigation/native";
import ReportBackground from "../components/ReportBackground";
import ReportEmptyState from "../components/ReportEmptyState";
import ReportInputEmptyState from "../components/ReportInputEmptyState";
import { ArrowLeft, MarkChatReadIcon, PaperOnlyIcon } from "../assets/icons";
import { getReportStatistic } from "../services/reportStatistics";

export default function ReportInputData() {
  const navigation = useNavigation();
  const route = useRoute();
  const reportId = route.params?.id;
  const hasInitialStatistic = route.params?.statistic?.success === true;
  const [status, setStatus] = useState("empty");
  const openEmptyForm = () => navigation.navigate("ReportInputForm", { id: reportId });

  // useEffect(() => {
  //   if (hasInitialStatistic) {
  //     setStatus("ready");
  //     return undefined;
  //   }
  //   if (!reportId) {
  //     setStatus("empty");
  //     return undefined;
  //   }

  //   let active = true;
  //   setStatus("loading");
  //   getReportStatistic(reportId)
  //     .then(({ data }) => {
  //       if (active) setStatus(data?.success === true ? "ready" : "empty");
  //     })
  //     .catch(() => {
  //       if (active) setStatus("error");
  //     });

  //   return () => {
  //     active = false;
  //   };
  // }, [hasInitialStatistic, reportId]);

  return (
    <ReportBackground style={styles.screen}>
      <ScrollView contentContainerStyle={styles.content}>
        <View style={styles.header}>
          <Pressable accessibilityRole="button" accessibilityLabel="Kembali" onPress={() => navigation.goBack()} style={styles.backButton}>
            <ArrowLeft />
          </Pressable>
          <Text style={styles.headerTitle}>Input Data</Text>
        </View>

        {status === "ready" ? (
          <View style={styles.reportCard}>
            <View style={styles.cardHeading}>
              <View style={styles.iconTile}>
                <PaperOnlyIcon width={18} height={18} customColor="#5423B5" />
              </View>
              <Text style={styles.cardHeadingText}>Input Data</Text>
            </View>
            <Text style={styles.reportTitle}>Laporan Implementasi 10 Profil MIHIIS</Text>
            <View style={styles.questionCount}>
              <View style={styles.questionIcon}>
                <MarkChatReadIcon width={16} height={16} customColor="#000" />
              </View>
              <Text style={styles.questionText}>32 Pertanyaan</Text>
            </View>
            <View style={styles.divider} />
            <View style={styles.actions}>
              <Pressable onPress={openEmptyForm} style={styles.secondaryButton}>
                <Text style={styles.secondaryButtonText}>Lihat Data</Text>
              </Pressable>
              <Pressable onPress={openEmptyForm} style={styles.primaryButton}>
                <Text style={styles.primaryButtonText}>Input Data</Text>
              </Pressable>
            </View>
          </View>
        ) : status === "empty" ? (
          <ReportInputEmptyState />
        ) : (
          <View style={styles.emptyPanel}>
            <ReportEmptyState
              title={status === "loading" ? "Memuat data laporan" : "Data laporan gagal dimuat"}
              description={status === "loading" ? "Mohon tunggu sebentar." : "Periksa koneksi lalu coba kembali."}
            />
          </View>
        )}
      </ScrollView>
    </ReportBackground>
  );
}

const styles = StyleSheet.create({
  screen: { flex: 1 },
  content: { flexGrow: 1, paddingHorizontal: 16, paddingTop: 44, paddingBottom: 24 },
  emptyPanel: { flex: 1, justifyContent: "center" },
  header: { height: 42, borderRadius: 24, backgroundColor: "#FFFFFF", alignItems: "center", justifyContent: "center" },
  backButton: { position: "absolute", left: 14, width: 28, height: 32, justifyContent: "center" },
  headerTitle: { color: "#171717", fontFamily: "Archivo-Bold", fontSize: 12 },
  reportCard: { marginTop: 16, padding: 16, borderRadius: 16, backgroundColor: "#FFFFFF", elevation: 2, shadowColor: "#34234A", shadowOpacity: 0.07, shadowRadius: 4, shadowOffset: { width: 0, height: 2 } },
  cardHeading: { flexDirection: "row", alignItems: "center", gap: 8 },
  iconTile: { width: 24, height: 24, borderRadius: 5, backgroundColor: "#F0E9FF", alignItems: "center", justifyContent: "center" },
  cardHeadingText: { color: "#171717", fontFamily: "Archivo-Bold", fontSize: 12 },
  reportTitle: { marginTop: 12, color: "#171717", fontFamily: "Archivo-Bold", fontSize: 13 },
  questionCount: { marginTop: 12, flexDirection: "row", alignItems: "center", gap: 8 },
  questionIcon: { width: 22, height: 22, borderRadius: 11, backgroundColor: "#F1F1F1", alignItems: "center", justifyContent: "center" },
  questionText: { color: "#999999", fontFamily: "Archivo-Regular", fontSize: 11 },
  divider: { height: 1, marginTop: 14, marginBottom: 12, backgroundColor: "#EEEEEE" },
  actions: { flexDirection: "row", gap: 10 },
  secondaryButton: { flex: 1, minHeight: 36, borderWidth: 1, borderColor: "#E7E7E7", borderRadius: 10, alignItems: "center", justifyContent: "center" },
  secondaryButtonText: { color: "#252525", fontFamily: "Archivo-Regular", fontSize: 11 },
  primaryButton: { flex: 1, minHeight: 36, borderWidth: 1, borderColor: "#E7E7E7", borderRadius: 10, alignItems: "center", justifyContent: "center" },
  primaryButtonText: { color: "#6724E2", fontFamily: "Archivo-Bold", fontSize: 11 },
});